import { Link } from "react-router-dom";
import React from "react";

export default function HeaderMidSeason() {
  return (
    <header className={"page-header with-background"}>
      <div className="page-header-inner">
        <div className="page-identity">
          <Link to="/" className="">
            <img
              src="/img/netflix-logo-ribbon.png"
              alt="NF"
              className="page-logo"
            />
          </Link>
          <Link to="/" className="page-identity-copy">
            <div className="page-identity-title">Series</div>
            <div className="page-identity-subtitle d-none d-sm-block">
              For Your Consideration
            </div>
            <div className="page-identity-subtitle d-block d-sm-none">FYC</div>
          </Link>
        </div>
      </div>
    </header>
  );
}
